angular.module('createMediaTagModule', []).controller('createMediaTagCtrl', ['$scope', 'options', '$q', 'trsHttpService', '$modalInstance', '$validation', 'mediaTagApiService', 'modalDialog',
    function($scope, options, $q, trsHttpService, $modalInstance, $validation, mediaTagApiService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                imageUploadUrl: trsHttpService.getMRURL() + '/thumb/upload'
            };
            $scope.data = {
                imgList: [],
                picList: []
            };
            $scope.maxPicSize = 9;
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data.params = Object.assign({}, options);
            $scope.data.labelName = options.type === 'person' ? '姓名' : '事物';
            $scope.data.params.files = [];
            if (options.id) {
                $scope.loadingPromise = mediaTagApiService.getTagDetail({id: options.id}).then(function(data) {
                    if (data.code === '200') {
                        $scope.data.params.labelName = data.datas.labelname;
                        $scope.data.params.labelDesc = data.datas.labeldesc;
                        if (data.datas.imageurl !== ''){
                            $scope.data.imgList = data.datas.imageurl.split(';');
                            $scope.data.picList = data.datas.imageurl.split(';');
                        }
                        
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                });
            }
        }

        /**
         *[close description] 取消按钮操作
        * @return  {[type]}  [return description]
        */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定按钮
         *
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            $scope.mediaTagForm.$pending = {};
            $validation
                .validate($scope.mediaTagForm)
                .success(function() {
                    if ($scope.data.imgList.length + $scope.data.params.files.length > $scope.maxPicSize) {
                        modalDialog.alertType('', '图片数量不能超过9张', 'warning', '');
                        return;
                    }
                    $scope.data.params.imageUrls = $scope.data.imgList.join(';');
                    $scope.loadingPromise = mediaTagApiService.saveTag($scope.data.params).then(function(data) {
                        if (data.code === '200') {
                            modalDialog.alertType('', '保存标签成功', 'success', false);
                            $modalInstance.close();
                        } else {
                            modalDialog.alertType('', data.msg, 'error', false);
                        }
                    });
                });
        };

        $scope.upload = function($files) {
            if (!$files) {
                return;
            }
            $scope.data.params.files = $scope.data.params.files.concat($files);
            for (var i = 0; i < $files.length; i++) {
                $scope.data.picList.push(URL.createObjectURL($files[i]));
            }
        };

        $scope.deletePic = function(index) {
            var indexSec = index - $scope.data.imgList.length;
            if (indexSec >= 0) {
                $scope.data.params.files.splice(indexSec, 1);
                $scope.data.picList.splice(index, 1);
            } else {
                $scope.data.imgList.splice(index, 1);
                $scope.data.picList.splice(index, 1);
            }
        };
    }
])
;
